export const buildQueryString = <T extends object>(
  path: string,
  queryArgs?: T,
): string => {
  if (!queryArgs || Object.keys(queryArgs).length === 0) {
    return path;
  }
  const queryString = new URLSearchParams(
    Object.entries(queryArgs).filter(([, value]: [string, unknown]) => value),
  ).toString();
  return `${path}?${queryString}`;
};
